import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';

import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, Translation, TranslocoLoader, TranslocoModule, translocoConfig } from '@ngneat/transloco';

import {
  PERSIST_TRANSLATIONS_STORAGE,
  TranslocoPersistTranslations,
  TranslocoPersistTranslationsModule,
} from '@ngneat/transloco-persist-translations';
import { TranslocoPreloadLangsModule } from '@ngneat/transloco-preload-langs';

import { environment, settings } from '@environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`./assets/i18n/${lang}.json`);
  }
}

let scope: string;

if (document.defaultView.location.hostname !== 'localhost') {
  scope = document.defaultView.location.pathname.split('/')[1] ?? 'dev';
} else {
  scope = 'dev';
}

@NgModule({
  imports: [
    TranslocoPreloadLangsModule.forRoot([...settings.supportedLanguages]),
    TranslocoPersistTranslationsModule.forRoot({
      loader: TranslocoHttpLoader,
      storage: {
        provide: PERSIST_TRANSLATIONS_STORAGE,
        useValue: sessionStorage,
      },
      storageKey: `${settings.prefix}-${scope}-xlate`,
    }),
  ],
  exports: [TranslocoModule],
  providers: [
    settings.i18nCache ? TranslocoPersistTranslations : { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [...settings.supportedLanguages],
        defaultLang: settings.defaultLanguage,
        fallbackLang: settings.defaultLanguage,
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          logMissingKey: true,
        },
      }),
    },
  ],
})
export class TranslocoRootModule {}
